import React from 'react';
import { Button, Typography } from '@telus-uds/components-web';
import PropTypes from 'prop-types';
import { useLocalizedStringsContext } from '../context/LocalizedStringsContext';

const MessageDialog = ({ responseObj, message, error, isClose }) => {
  const { rejectedSheets } = responseObj && responseObj;
  const localizedStrings = useLocalizedStringsContext();
  const {
    USERS: {
      BULK_FILE_UPLOAD: { CLOSE }
    }
  } = localizedStrings;
  const displayError = () => {
    return (
      <Typography variant={{ colour: 'error' }}>
        {error}
        {rejectedSheets && rejectedSheets.map((sheet, index) => index > 0 ? ', ' + sheet : sheet)}
      </Typography>
    );
  }
  return (
    <>
      <div id="overlay-layer">
        <div id="overlay-story">
          <div>
            <span>{message}
            {error && displayError()}
            </span>
          </div>
          {/* <div style={{ marginTop: 20 }}>
                <h1>{BULK_FILE_USER} : {bulkUsers.length}</h1>
                <h1>{REGISTER_USER}: {registeredUsers.length}</h1>
                <h1>{REJECTED_USER}: {rejectedUsers.length}</h1>
                {rejectedUsers && rejectedUsers.length > 0 && <Table rejectedUsers={rejectedUsers} /> }    
              </div> */}
          <Button variant={{ priority: 'high' }} type="button"
            style={{ marginTop: '15px' }}
            
            onClick={() => isClose()}
          >
            {CLOSE}
          </Button>
        </div>
      </div>
    </>
  );
};

MessageDialog.propTypes = {
  responseObj: PropTypes.objectOf(PropTypes.object).isRequired,
  message: PropTypes.string.isRequired,
  error: PropTypes.string.isRequired,
  isClose: PropTypes.func.isRequired
};
export default MessageDialog;
